import { IFormControl } from '../interfaces';
import { ChangeEventHandler, FocusEventHandler, MouseEventHandler, ReactNode } from 'react';
import { ICountry } from '../../../domain/addresses/interfaces';

/**
 * Country & state form fields dependent on each other.
 */
interface ICountryAndStateFieldsProps {
    idPrefix: string,
    countryIdControl: IFormControl,
    stateIdControl: IFormControl,
    countries: ICountry[],

    // event handlers
    onBlur?: FocusEventHandler,
    onCountryChange?: ChangeEventHandler,
    onStateChange?: ChangeEventHandler,
    onClick?: MouseEventHandler,

    // html content
    comment?: ReactNode,

    // styles
    rootClasses?: string,
    selectClasses?: string,

    qaCountry?: string,
    qaState?: string,
}

const CountryAndStateFields = (props: ICountryAndStateFieldsProps) => {

    const selectedCountry = props.countries.find(country => country.countryID.toString() === props.countryIdControl.value.toString());
    const selectedState = selectedCountry && selectedCountry.states.find(state => state.stateID.toString() === props.stateIdControl.value.toString());

    return (
        <div className={ props.rootClasses ? props.rootClasses : 'mb-6'}>
            <div className="mb-3">
                <div className={`w-form-field ${!props.countryIdControl.isValid ? 'w-form-error' : ''} `}>

                    <select
                        id={ `${ props.idPrefix }CountryId` }
                        className={`w-form-tb ${ props.selectClasses || '' } ${ selectedCountry ? 'not-empty': '' } `}
                        value={ props.countryIdControl.value }
                        data-qa={ props.qaCountry }
                        onBlur={ props.onBlur }
                        onChange={ props.onCountryChange }
                        onClick={  props.onClick }
                    >
                        <option value={ 0 }>Select Country</option>
                        {
                            props.countries.map(country => {
                                return (
                                    <option value={ country.countryID } key={ country.countryID }>{ country.countryDisplayName }</option>
                                )
                            })
                        }
                    </select>

                    <label htmlFor={ `${ props.idPrefix }CountryId` } className="w-form-label">Country</label>
                </div>

                { props.countryIdControl.isValid && props.comment }

                {
                    !props.countryIdControl.isValid &&
                    <div className="text-red text-sm" role="alert">{ props.countryIdControl.error }</div>
                }
            </div>

            {
                selectedCountry && selectedCountry.states && selectedCountry.states.length > 0 &&
                <div>
                    <div className={`w-form-field ${!props.stateIdControl.isValid ? 'w-form-error' : ''} `}>

                        <select
                            id={ `${ props.idPrefix }StateId` }
                            className={`w-form-tb ${ props.selectClasses || '' }  ${ selectedState ? 'not-empty': '' } `}
                            value={ props.stateIdControl.value }
                            data-qa={ props.qaState }
                            onBlur={ props.onBlur }
                            onChange={ props.onStateChange }
                            onClick={  props.onClick }
                        >
                            <option value={ 0 }>Select State</option>
                            {
                                selectedCountry.states.map(state => {
                                    return (
                                        <option value={ state.stateID } key={ state.stateID }>{ state.stateDisplayName }</option>
                                    )
                                })
                            }
                        </select>

                        <label htmlFor={ `${ props.idPrefix }StateId` } className="w-form-label">State</label>
                    </div>

                    { props.stateIdControl.isValid && props.comment }

                    {
                        !props.stateIdControl.isValid &&
                        <div className="text-red text-sm" role="alert">{ props.stateIdControl.error }</div>
                    }
                </div>
            }
        </div>
    )
};

export default CountryAndStateFields;